import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/menuIcons/creditcard.svg'


const _hoisted_1 = { class: "table columns2" }
const _hoisted_2 = {
  style: {"grid-area":"1 / cta"},
  class: "rowend-top"
}
const _hoisted_3 = { class: "pad-s" }
const _hoisted_4 = {
  style: {"grid-area":"1 / counterparty"},
  class: "row-top"
}
const _hoisted_5 = { class: "col mleft-04" }
const _hoisted_6 = {
  style: {"grid-area":"1 / info"},
  class: "row-top"
}
const _hoisted_7 = {
  style: {"grid-area":"1 / print"},
  class: "row-top"
}
const _hoisted_8 = {
  style: {"grid-area":"1 / amounts"},
  class: "row-top"
}
const _hoisted_9 = { class: "pad-m w-full" }
const _hoisted_10 = {
  style: {"padding":"0"},
  class: "w-full row mtop-06"
}
const _hoisted_11 = {
  style: {"grid-area":"1 / partial","width":"100px"},
  class: "row-top"
}

import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import editTransaction from './editTransaction.vue'
import newTransaction from './newTransaction.vue'
import gen from '@/functions/general.js';
import { formatMatricule } from '@/functions/lu.js';
import { apiDateString, apiAmountCurrency } from '@/api/apicommon';
import patientapi from '@/api/patientapi';
import showBill from './showBill.vue';
import { AccountingApi } from '@/apiGenerate/medserver';
import { medServerApiConfig } from '@/config/medserver-api.config'
import { useCurrentEntryStore } from '@/stores/currentEntry';
import PersonService from "@/services/PersonService";


export default /*@__PURE__*/_defineComponent({
  __name: 'invoiceCard',
  props: {
  invoice: {
    type: Object,
    required: true,
  },
  //either currChannel 
  currChannel: {
    type: Object,
    default: null,
  },
  //or currFinancialGroup
  currFinancialGroup: {
    type: Object,
    default: null,
  },
  pwrHealthPro: {
    type: Object,
    default: null,
  },
  hasMultipleHealthPro: {
    type: Boolean,
    default: false,
  },
  isTransparent: {
      type: Boolean,
      default: false,
  },
  isSelectable: {
      type: Boolean,
      default: true,
  },
  isNavigable: {
      type: Boolean,
      default: false,
  },
  allCurrChannels: {
      type: Array,
      default: null,
  }
},
  emits: ['reload', 'ctaClicked', 'navigate'],
  setup(__props, { emit: __emit }) {

const accountingApi = new AccountingApi(medServerApiConfig)
const currentEntryStore = useCurrentEntryStore();
const emits = __emit
const props = __props
const { t } = useI18n();
const dropd = ref(null)

function close() {
  dropd.value = ''
  emits('reload')
}

async function updateTransactionChannel(channel, transaction) {
  const channelId = channel.id;
  const transactionId = transaction.transactionId;
  dropd.value = "";
  await accountingApi.updateTransactionChannel({
    transactionId: transactionId,
    updateTransactionChannelRequest: { newChannelId: channelId }
  });
  emits('reload');
}

const currInvoice = computed(() => {
  return (props.invoice)
})

async function accessPatient(pwrPatient: any) {
  const patientId = pwrPatient.id;
  currentEntryStore.openPatientModal('invoiceHistory');
  await currentEntryStore.setModalPatient(patientId);
}

const isTransactionPossible = computed(() => {
  if (props.invoice.invoiceStatus === "Precomplete") {return true}
  const sourceChannelType = props.currChannel.type
  if (["BankAccount", "Cash", "Cancelled"].includes(sourceChannelType)) {return false}
  return true
})

function getAmountWithSign(amount, currencyIso) {
  const isNegative = amount.toString().startsWith('-');
  const absAmount = isNegative ? amount.toString().substring(1) : amount;
  const sign = isNegative ? '+ ' : '- ';
  return sign + apiAmountCurrency(absAmount, currencyIso);
}

function invoiceCta() {
  currInvoice.value.selected = !currInvoice.value.selected
  emits('ctaClicked', props.invoice)
}

function sumTransactionsByChannelId(secondaryTransaction, transactions) {
  const targetChannelId = secondaryTransaction.sourceFinancialChannelId;
  const total = transactions
    .filter(transaction => transaction.financialChannelId === targetChannelId)
    .reduce((sum, transaction) => sum + parseFloat(transaction.amount || 0), 0)
  return total.toFixed(2)
}

const personName = computed(() => {
  const pwr = props.invoice.pwrCounterParty;
  return PersonService.formatName(pwr.lastName, pwr.firstName);
})

async function printPdf() {
  const patientDocumentId = props.invoice.patientDocument?.patientDocumentId
  if (!patientDocumentId) {console.log("Errror. No patientDocumentId"); return; }
  const respBlob = await patientapi.getPatientDocumentPdfStream(patientDocumentId)
  if (!respBlob) {return;}
  gen.printBlob(respBlob, "Pdf")
}


return (_ctx: any,_cache: any) => {
  const _component_buttonGroup = _resolveComponent("buttonGroup")!
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_switchGroup = _resolveComponent("switchGroup")!
  const _component_text_item = _resolveComponent("text-item")!
  const _component_dropdownBox = _resolveComponent("dropdownBox")!
  const _component_inputLineNew2 = _resolveComponent("inputLineNew2")!
  const _component_inputBox = _resolveComponent("inputBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      style: {"grid-row":"1","grid-column":"3 / -3"},
      class: _normalizeClass(__props.isTransparent ? 'bg-transparent' : 'bg-card')
    }, null, 2),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (__props.isNavigable)
          ? (_openBlock(), _createBlock(_component_buttonGroup, {
              key: 0,
              class: "align-center",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('navigate', props.invoice)))
            }, {
              default: _withCtx(() => _cache[13] || (_cache[13] = [
                _createElementVNode("img", { src: _imports_0 }, null, -1)
              ])),
              _: 1
            }))
          : (__props.isSelectable)
            ? (_openBlock(), _createBlock(_component_switchGroup, {
                key: 1,
                active: currInvoice.value.selected,
                style: {"padding-left":"1rem","padding-right":"1rem"},
                onClick: _cache[1] || (_cache[1] = ($event: any) => (invoiceCta()))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_item, {
                    icon: "check",
                    styles: "size-m",
                    class: _normalizeClass(currInvoice.value.selected ? 'img-white' : '')
                  }, null, 8, ["class"])
                ]),
                _: 1
              }, 8, ["active"]))
            : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_buttonGroup, {
        class: "w-full",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (accessPatient(__props.invoice.pwrCounterParty)))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_text_item, {
              txt: personName.value,
              class: "mw-14"
            }, null, 8, ["txt"]),
            _createVNode(_component_text_item, {
              txt: __props.invoice.pwrCounterParty.hasCns ? _unref(formatMatricule)(__props.invoice.pwrCounterParty.cnsAffiliationNumber) : _unref(t)('accounting.invoice.notCns'),
              styles: "main-l"
            }, null, 8, ["txt"])
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_dropdownBox, {
        style: {"grid-area":"1 / info"},
        modelValue: dropd.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dropd).value = $event)),
        openOn: "Info",
        class: "w-full"
      }, {
        dropd: _withCtx(() => [
          _createVNode(showBill, { invoice: currInvoice.value }, null, 8, ["invoice"])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_buttonGroup, { class: "w-full" }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_text_item, {
                  txt: __props.invoice.invoiceReference
                }, null, 8, ["txt"]),
                (__props.currFinancialGroup)
                  ? (_openBlock(), _createBlock(_component_text_item, {
                      key: 0,
                      txt: props.currFinancialGroup.title,
                      styles: "main-l"
                    }, null, 8, ["txt"]))
                  : _createCommentVNode("", true),
                (props.invoice.patientDocument?.luBillEtransferData?.cancellationReason)
                  ? (_openBlock(), _createBlock(_component_text_item, {
                      key: 1,
                      txt: props.invoice.patientDocument?.luBillEtransferData?.cancellationReason,
                      class: "linebreak",
                      styles: "main-l font-m"
                    }, null, 8, ["txt"]))
                  : _createCommentVNode("", true),
                (props.hasMultipleHealthPro)
                  ? (_openBlock(), _createBlock(_component_text_item, {
                      key: 2,
                      txt: props.pwrHealthPro.firstName + ' ' + props.pwrHealthPro.lastName,
                      styles: "main-l"
                    }, null, 8, ["txt"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_text_item, {
                  txt: __props.invoice.invoiceInfo,
                  class: "linebreak",
                  styles: "main-l"
                }, null, 8, ["txt"]),
                (__props.invoice.latestReminderGroup)
                  ? (_openBlock(), _createBlock(_component_text_item, {
                      key: 3,
                      txt: _unref(t)('accounting.invoice.reminder', {sequence: __props.invoice.latestReminderGroup.reminderLevel}),
                      class: "linebreak",
                      styles: "main-l"
                    }, null, 8, ["txt"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (__props.invoice.invoiceStatus !== 'Precomplete')
        ? (_openBlock(), _createBlock(_component_buttonGroup, {
            key: 0,
            onClick: _cache[4] || (_cache[4] = ($event: any) => (printPdf())),
            class: "mtop-02"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_svg_item, {
                icon: "printer",
                styles: "main-l"
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_dropdownBox, {
          modelValue: dropd.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((dropd).value = $event)),
          openOn: 'ShowBill'
        }, {
          dropd: _withCtx(() => [
            _createVNode(showBill, { invoice: currInvoice.value }, null, 8, ["invoice"])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_buttonGroup, {
              style: {"padding":"0"},
              class: _normalizeClass(["w-full row", __props.invoice.transactions?.length === 0 && __props.currChannel?.type === 'RemainingBalance' ? 'of-current-filter' : ''])
            }, {
              default: _withCtx(() => [
                _createVNode(_component_text_item, {
                  txt: _unref(apiDateString)(__props.invoice.invoiceDateTime),
                  styles: "main-h"
                }, null, 8, ["txt"]),
                _cache[14] || (_cache[14] = _createElementVNode("div", { style: {"margin-left":"auto","width":"1rem"} }, null, -1)),
                _createVNode(_component_text_item, {
                  txt: _unref(apiAmountCurrency)(__props.invoice.amount, __props.invoice.currencyIso),
                  styles: "main-h"
                }, null, 8, ["txt"])
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        (__props.invoice.transactions)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.invoice?.transactions, (priTransaction, index) => {
              return (_openBlock(), _createBlock(_component_dropdownBox, {
                key: index,
                modelValue: dropd.value,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((dropd).value = $event)),
                openOn: 'Transaction' + index
              }, {
                dropd: _withCtx(() => [
                  _createVNode(editTransaction, {
                    invoice: currInvoice.value,
                    transaction: priTransaction,
                    currChannel: __props.currChannel,
                    allCurrChannels: __props.allCurrChannels,
                    onClose: _cache[6] || (_cache[6] = ($event: any) => (close())),
                    onModifyTxChannel: (channel) => updateTransactionChannel(channel, priTransaction)
                  }, null, 8, ["invoice", "transaction", "currChannel", "allCurrChannels", "onModifyTxChannel"])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_buttonGroup, {
                    style: {"padding":"0"},
                    class: _normalizeClass(["w-full row", __props.currChannel?.id === priTransaction.financialChannelId ? 'of-current-filter' : ''])
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_text_item, {
                        txt: _unref(apiDateString)(priTransaction.transactionDateTime),
                        class: "amount-col-1",
                        styles: "main-l"
                      }, null, 8, ["txt"]),
                      _createVNode(_component_text_item, {
                        txt: priTransaction.channelTitle,
                        class: "mleft-04 amount-col-2",
                        styles: "main-l"
                      }, null, 8, ["txt"]),
                      _createVNode(_component_text_item, {
                        txt: getAmountWithSign(priTransaction.amount, priTransaction.currencyIso),
                        class: "amount-col-3 align-r",
                        styles: "main-l",
                        style: {"margin-left":"auto"}
                      }, null, 8, ["txt"])
                    ]),
                    _: 2
                  }, 1032, ["class"])
                ]),
                _: 2
              }, 1032, ["modelValue", "openOn"]))
            }), 128))
          : _createCommentVNode("", true),
        (__props.invoice.transactions?.length)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _cache[16] || (_cache[16] = _createElementVNode("div", { class: "line-h w-full mtop-02" }, null, -1)),
              _createVNode(_component_dropdownBox, {
                modelValue: dropd.value,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((dropd).value = $event)),
                openOn: "NewTransaction"
              }, {
                dropd: _withCtx(() => [
                  _createVNode(newTransaction, {
                    invoice: currInvoice.value,
                    allCurrChannels: __props.allCurrChannels,
                    onClose: _cache[8] || (_cache[8] = ($event: any) => (close()))
                  }, null, 8, ["invoice", "allCurrChannels"])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_buttonGroup, {
                    style: {"padding":"0"},
                    class: _normalizeClass(["w-full row mtop-02", __props.currChannel?.type === 'RemainingBalance' ? 'of-current-filter' : ''])
                  }, {
                    default: _withCtx(() => [
                      _cache[15] || (_cache[15] = _createElementVNode("div", { style: {"margin-left":"auto","width":"0.4rem"} }, null, -1)),
                      _createVNode(_component_text_item, {
                        txt: _unref(apiAmountCurrency)(__props.invoice.remainingBalance, __props.invoice.currencyIso),
                        styles: "main-l"
                      }, null, 8, ["txt"])
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ], 64))
          : _createCommentVNode("", true),
        (__props.invoice.transactions)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(__props.invoice?.secondaryTransactions, (secTransaction, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_text_item, {
                    txt: secTransaction.sourceChannelTitle,
                    styles: "main-h"
                  }, null, 8, ["txt"]),
                  _cache[17] || (_cache[17] = _createElementVNode("div", { style: {"margin-left":"auto","width":"1rem"} }, null, -1)),
                  _createVNode(_component_text_item, {
                    txt: _unref(apiAmountCurrency)(sumTransactionsByChannelId(secTransaction, __props.invoice.transactions), __props.invoice.currencyIso)
                  }, null, 8, ["txt"])
                ]),
                _createVNode(_component_dropdownBox, {
                  modelValue: dropd.value,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((dropd).value = $event)),
                  openOn: 'SecondaryTransaction' + index
                }, {
                  dropd: _withCtx(() => [
                    _createVNode(editTransaction, {
                      invoice: currInvoice.value,
                      transaction: secTransaction,
                      currChannel: __props.currChannel,
                      allCurrChannels: __props.allCurrChannels,
                      onClose: _cache[10] || (_cache[10] = ($event: any) => (close())),
                      onModifyTxChannel: (channel) => updateTransactionChannel(channel, secTransaction)
                    }, null, 8, ["invoice", "transaction", "currChannel", "allCurrChannels", "onModifyTxChannel"])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_buttonGroup, {
                      style: {"padding":"0"},
                      class: _normalizeClass(["w-full row", __props.currChannel?.id === secTransaction.financialChannelId ? 'of-current-filter' : ''])
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_text_item, {
                          txt: _unref(apiDateString)(secTransaction.transactionDateTime),
                          styles: "main-l",
                          class: "amount-col-1"
                        }, null, 8, ["txt"]),
                        _createVNode(_component_text_item, {
                          txt: secTransaction.channelTitle,
                          class: "mleft-04 amount-col-2",
                          styles: "main-l"
                        }, null, 8, ["txt"]),
                        _createVNode(_component_text_item, {
                          txt: getAmountWithSign(secTransaction.amount, secTransaction.currencyIso),
                          class: "amount-col-3 align-r",
                          styles: "main-l",
                          style: {"margin-left":"auto"}
                        }, null, 8, ["txt"])
                      ]),
                      _: 2
                    }, 1032, ["class"])
                  ]),
                  _: 2
                }, 1032, ["modelValue", "openOn"])
              ], 64))
            }), 128))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      (currInvoice.value.selected && currInvoice.value.invoiceStatus !== 'Precomplete' && isTransactionPossible.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_inputBox, null, {
              default: _withCtx(() => [
                _createVNode(_component_inputLineNew2, {
                  ref: "inputRef",
                  modelValue: currInvoice.value.partial,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((currInvoice.value.partial) = $event)),
                  onKeydown: _unref(gen).onlyNumber,
                  onPaste: _unref(gen).onlyNumber
                }, null, 8, ["modelValue", "onKeydown", "onPaste"])
              ]),
              _: 1
            }),
            _createVNode(_component_text_item, {
              txt: " €",
              styles: "main-m",
              class: "pad-m",
              style: {"width":"30px"}
            })
          ], 64))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})